import Icon from 'blocks.simple/icon/icon'
import translate from 'core/translate'
import { cn } from 'ethcss'
import React from 'react'
import { grid } from 'theme'
import styles from '../uploader.styles.jcss'
import Button from 'blocks.simple/button/button'
import Dropzone from 'react-dropzone'

const FileInput = ({
    uploadRef,
    addFiles,
    isCsv,
}: {
    uploadRef: React.RefObject<HTMLInputElement>
    addFiles: (files: File[]) => void
    isCsv: boolean
}) => {
    return (
        <Dropzone
            onDrop={(accepted: File[]) => {
                addFiles(accepted)
            }}
            accept={
                isCsv
                    ? { 'text/csv': ['.csv'] }
                    : { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }
            }
            multiple={false}
        >
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className={cn(styles.section, grid.mb_miniPlus)}>
                    <Icon type={'fileItem'} size={25} />
                    <div className={styles.hint}>{translate(isCsv ? 'uploadFileHintCSV' : 'uploadFileHintXLSX')}</div>
                    <input {...getInputProps()} ref={uploadRef} id="fileUpload" style={{ display: 'none' }} />
                    <Button
                        className={styles.uploadBtn}
                        mod={'fill'}
                        onClick={(e: React.MouseEvent) => {
                            e.stopPropagation()
                            if (uploadRef.current) {
                                uploadRef.current.click()
                            }
                        }}
                    >
                        {translate('uploadDocument')}
                    </Button>
                </div>
            )}
        </Dropzone>
    )
}

export default FileInput
